module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "economy-operations"
  }, [_c('content-switch', {
    attrs: {
      "items": _vm.switchItems,
      "selectedItem": _vm.selectedItem,
      "counts": _vm.counts
    },
    on: {
      "selectItem": function($event) {
        return _vm.handleSelectItem($event)
      }
    }
  }), _vm._v(" "), _c('noInvoiceProjects-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'noInvoiceProjects'),
      expression: "selectedItem === 'noInvoiceProjects'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('noInvoiceProjects', $event)
      }
    }
  }), _vm._v(" "), _c('unpaidInvoices-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'unpaidInvoices'),
      expression: "selectedItem === 'unpaidInvoices'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('unpaidInvoices', $event)
      }
    }
  }), _vm._v(" "), _c('exceeded-payments', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'exceededPayments'),
      expression: "selectedItem === 'exceededPayments'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('exceededPayments', $event)
      }
    }
  }), _vm._v(" "), _c('all-invoices', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'allInvoices'),
      expression: "selectedItem === 'allInvoices'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('allInvoices', $event)
      }
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e9586f9c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e9586f9c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/economy/operations.vue
// module id = 890
// module chunks = 0